/* componentes nativos */
import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Router, Route, IndexRoute, hashHistory } from 'react-router';
import Cookies from 'universal-cookie';
import TagManager from 'react-gtm-module';
// import $ from "jquery";
import base64 from 'base-64';
import './index.css';

/* componentes criados */
import App, { childMenu } from './components/app/.mixins/App';
import Login from './components/login/.mixins/Login';
import Home from './components/app/childrens/ui/home/.mixins/Home';
import Grupos from './components/app/childrens/ui/grupos_lista/.mixins/Grupos_lista';
import Grupos_ae from './components/app/childrens/ui/grupos_ae/.mixins/Grupos_ae';
import Comunicados_lista from './components/app/childrens/ui/comunicados_lista/.mixins';
import Contatos_lista from './components/app/childrens/ui/contatos_lista/.mixins';
import Comunicados_contatos_ae from './components/app/childrens/ui/comunicados_contatos_ae/.mixins/Comunicados_contatos_ae';
import Error from './components/error/.mixins/Error';
import Perfil from './components/app/childrens/ui/perfil/.mixins/Perfil';
import Usuarios from './components/app/childrens/ui/usuarios/.mixins/Usuarios';
import PedidosNova from './components/app/childrens/ui/pedidos/.mixins/Pedidos';
import PedidosPendentes from './components/app/childrens/ui/consultaPedidos/Pendentes/.mixins';
import PedidosAgendados from './components/app/childrens/ui/consultaPedidos/Agendados/.mixins';
import Etiquetas from './components/app/childrens/ui/etiquetas/.mixins/Etiquetas';
//import Pagamentos from './components/app/childrens/ui/pagamentos/.mixins/Pagamentos';
import Arquivos from './components/app/childrens/ui/arquivos/.mixins/Arquivos';
import Devolucao from './components/app/childrens/ui/devolucoes/.mixins/Devolucoes';
import Produtos from './components/app/childrens/ui/produtos/.mixins/Produtos';
import Cotacoes from './components/app/childrens/ui/cotacoes/.mixins/Cotacoes';
import Permissoes from './components/app/childrens/ui/permissoes/.mixins/Permissoes';
import Permissoes_ae from './components/app/childrens/ui/permissoes_ae/.mixins/';
//import Notas from './components/app/childrens/ui/notas/.mixins/Notas';
import { Invoices } from './pages/invoices';
import { SendInvoice } from './pages/sendInvoice';
import Qualidade from './components/app/childrens/ui/qualidade/.mixins';
import Protocolos from './components/app/childrens/ui/protocolo/.mixins/Protocolo';
import ProtocoloLogistico from './components/app/childrens/ui/protocoloLogistico/.mixins/ProtocoloLogistico';
import Temas from './components/app/childrens/ui/temas/.mixins';
import Logs from './components/app/childrens/ui/logs/.mixins';
import PedidoCompra from './components/app/childrens/ui/pedidoCompra/.mixins';
import Scorecard from './components/app/childrens/ui/scorecard/.mixins';
import PreviaNota from './components/app/childrens/ui/previaNota/.mixins';
import Compliance from './components/app/childrens/ui/compliance_lista/.mixins';
import OpcoesRecebimento from './components/app/childrens/ui/opcoesRecebimento/.mixins';
import GrupoOpcoesRecebimento from './components/app/childrens/ui/gruposOpcoesRecebimento/.mixins/GrupoOpcoesRecebimento';
import GrupoOpcoesRecebimento_ae from './components/app/childrens/ui/gruposOpcoesRecebimento_ae/.mixins/index';
import ConfOpcoesRecebimento from './components/app/childrens/ui/confOpcoesRecebimento/.mixins/confOpcoesRecebimento';
import ConfGrupoFornecedor from './components/app/childrens/ui/confGrupoFornecedor-OpcRec/.mixins/confGrupoFornecedor';
import ConfGrupoFornecedor_ae from './components/app/childrens/ui/confGrupoFornecedor-OpcRec_ae/.mixins/ConfGrupoFornecedor_ae';
import ManutencaoCondicoesPagamento from './components/app/childrens/ui/manutencaoCondicoesPagamento/.mixins/condicoesPagamento.js';
import ManutencaoCondicoesPagamento_ae from './components/app/childrens/ui/manutencaoCondicoesPagamento-ae/.mixins/index';
import GerenciarPedidos from './components/app/childrens/ui/gerenciarPedidos/.mixins';
import AlterarOpcRecebProtocAgend from './components/app/childrens/ui/gerenciarPedidos/childrens/tabs/childrens/protocoloAgendamento/childrens/alteraPagamentoOpcaoRecebimento/.mixins/index';
import { AdicionarFichaTecnica } from './components/app/childrens/ui/qualidade/childrens/adicionarFichaTecnica/.mixins';
import { OrderHistory } from 'pages/orderHistory';
import { OrderHistoryDetails } from 'pages/orderHistoryDetails';
import { ApolloClientProvider } from './services/apollo';
import { DocumentSignature } from './pages/documentSignature';
import { Payments } from './pages/payments';

/* controllers */
import Auth from './controllers/auth';
import Index_Controller from './controllers/index';
import Log from './controllers/log';
import Pessoa_controller from './controllers/pessoa';
import theme from './config/palette';
import { AuthProvider } from './contexts/AuthContext';
import { AuthProvider as AuthProviderTs } from './contexts/auth';
import { usePermissions } from './hooks/usePermissions';
import { ComplementaryRegistration } from './pages/documents/complementaryRegistration';
import { ProductReturn } from './pages/quality/productReturn';
import { ProductReturnAdd } from './pages/quality/productReturnAdd';
import { ProductReturnView } from './pages/quality/productReturnView';
import { RecoilRoot } from 'recoil';
import Contact from 'pages/contact';
import AnnouncementPage from 'pages/documents/announcement';
import { ManageOrderProvider } from 'contexts/manageOrder';
import { Forms } from 'pages/forms';
import { FormsCreate } from 'pages/formsCreate';
import { FormAnswer } from 'pages/formAnswer';
import { SuppliersProvider } from 'contexts/SuppliersContext';

const captureInformations = async (token) => {
  let str = '';
  try {
    const r_information = await Index_Controller.getInformation();

    //auditoria
    str =
      'Informações de usuário logado! ' +
      'Response:( Method: ' +
      r_information.res.request.method +
      ', StatusCode: ' +
      r_information.res.statusCode +
      ', Body: ' +
      r_information.body +
      ' )';
    Log.info(token, str);
  } catch (error) {
    //auditoria
    str =
      'Erro na recuperação de informações do usuário logado! ' +
      'Error:( Message: ' +
      error.message +
      ', Stack: ' +
      error.stack +
      ' )';
    Log.error(token, str);
  }
};

const loadInformationsUser = async () => {
  const cookies = new Cookies();
  const token = cookies.get('User-Token');

  try {
    const o_pessoa = await Pessoa_controller.getByToken(token);
    let j_pessoa = JSON.parse(o_pessoa.body);
    if (o_pessoa.res.statusCode === 200) {
      return j_pessoa.itens;
    } else {
      throw new Error('Campos necessários, não foram retornados pelo servidor!');
    }
  } catch (error) {
    //auditoria
    const str = `Erro no retorno de dados de perfil!
        Error:( Message: ${error.message}, Stack: ${error.stack} )`;
    Log.error(token, str);
  }
};

const run = async () => {
  const cookies = new Cookies();
  const token = cookies.get('User-Token');

  let permissions;
  let role;
  if (token) {
    const { userPermissions, userRole } = await usePermissions();
    permissions = userPermissions;
    role = userRole;
  }

  try {
    if (process.env.REACT_APP_DEBUG === 'TRUE') {
      console.log(
        `AMBIENTE: NODE_ENV=${process.env.NODE_ENV}, REACT_APP_URL_BACKEND=${process.env.REACT_APP_URL_BACKEND}`
      );
    }

    let r_auth = null;
    let j_r_auth = null;

    if (token !== '' && token != null) {
      r_auth = await Auth.check_auth(token);
      j_r_auth = JSON.parse(r_auth.body);
    } else {
      console.log('=== token ===', token);
      TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS });
      //sem cookie setado
      return ReactDOM.render(<Login />, document.getElementById('root'));
    }

    let path = window.location.pathname.split('/');
    if (path && path[1] && path[1].includes('status')) {
      ReactDOM.render(
        `Frontend em funcionamento na versão: ${process.env.REACT_APP_VERSION}`,
        document.getElementById('root')
      );
    } else if (r_auth.res.statusCode === 200 && j_r_auth.dataRenovacao) {
      ReactDOM.render(<Perfil renov={true} />, document.getElementById('root'));
    } else if (r_auth.res.statusCode === 200 && !j_r_auth.dataRenovacao) {
      //captura informações de usuário logado
      captureInformations(token);

      //captura id do usuário logado
      const { codigo } = await loadInformationsUser();

      let ga_informations = {};
      // garante que o valor não está nulo
      if (role != null) {
        ga_informations = {
          dimension1: codigo,
          dimension4: role
        };
        cookies.set('ga_informations', base64.encode(JSON.stringify(ga_informations)), { path: '/' });
      }

      TagManager.initialize({
        gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS,
        dataLayer: ga_informations
      });

      //define avisado pedidos
      window.alertPedido = true;

      // funcionalidadeDev();

      const checkPermission =
        permissions['gerenciar-pedidos'] &&
        permissions['gerenciar-pedidos.protocolo-agendamento'] &&
        permissions['opcoes-de-recebimento'];

      //Autentificado
      ReactDOM.render(
        <AuthProvider permissions={permissions} role={role}>
          <AuthProviderTs permissions={permissions} role={role}>
            <RecoilRoot>
              <ApolloClientProvider>
                <ManageOrderProvider>
                  <SuppliersProvider>
                    <ThemeProvider theme={theme}>
                      <Router history={hashHistory}>
                        <Route path="/" component={App}>
                          <IndexRoute component={Home} />

                          {permissions['manter-comunicados'] && (
                            <>
                              <Route path="/comunicados" component={Comunicados_lista} title="comunicado" />

                              <Route path="/comunicados-ae" component={Comunicados_contatos_ae} title="comunicado" />

                              <Route path="/comunicados-ae/:id" component={Comunicados_contatos_ae} title="comunicado" />
                            </>
                          )}

                          {permissions['manter-contatos'] && (
                            <>
                              <Route path="/contatos" component={Contatos_lista} title="contato" />

                              <Route path="/contatos-ae" component={Comunicados_contatos_ae} title="contato" />

                              <Route path="/contatos-ae/:id" component={Comunicados_contatos_ae} title="contato" />
                            </>
                          )}

                          {permissions['alterar-perfil'] && <Route path="/perfil" component={Perfil} />}

                          {permissions['lista-de-pedidos-pendentes'] && (
                            <Route
                              path="/pendentes"
                              component={PedidosPendentes}
                              link="pendentes"
                              title="Pedidos não agendados"
                            />
                          )}

                          {permissions['nova-tela-pedidos-pendentes'] && (
                            <Route path="/pendentesNova" component={PedidosNova} title="pedidos não agendados" />
                          )}

                          {permissions['lista-de-pedidos-agendados'] && (
                            <Route path="/agendados" component={PedidosAgendados} title="pedidos agendados" />
                          )}

                          <Route path="/etiquetas" component={Etiquetas} />
                          {/*
                            {permissions["lista-de-pagamentos"] &&
                              <Route path="/pagamentos-old" component={Pagamentos} />
                            } */}

                          {permissions['lista-de-pagamentos'] && <Route path="/pagamentos" component={Payments} />}

                          <Route path="/comunicados/arquivos/:id" component={AnnouncementPage} link="comunicado" />

                          <Route path="/contatos/arquivos/:id" component={Arquivos} link="contato" />

                          <Route path="/pedidos/arquivos/:cd_fil/:cd_pedido" component={Arquivos} link="pedido" />

                          <Route path="/pedidoCompra/:cd_fil/:nr_pc/:language" component={PedidoCompra} />

                          <Route path="/devolucoes" component={Devolucao} />

                          <Route path="/produtos" component={Produtos} />

                          <Route path="/cotacoes" component={Cotacoes} />

                          <Route path="/previaNota" component={PreviaNota} />

                          <Route path="/temas" component={Temas} />

                          {permissions['user-compliance'] && (
                            <>
                              <Route path="/compliance" component={Compliance} />
                              <Route path="/document-signature/:id" component={DocumentSignature} />
                            </>
                          )}

                          {permissions['opcoes-de-recebimento'] && (
                            <Route path="/opcoesRecebimento" component={OpcoesRecebimento} />
                          )}

                          {permissions['grupos-opcoes-de-recebimento'] && (
                            <>
                              <Route path="/grupoOpcoesRecebimento" component={GrupoOpcoesRecebimento} />

                              <Route path="/grupoOpcoesRecebimento-ae/:id" component={GrupoOpcoesRecebimento_ae} />

                              <Route path="/grupoOpcoesRecebimento-ae" component={GrupoOpcoesRecebimento_ae} />

                              <Route path="/confOpcoesRecebimento/:id" component={ConfOpcoesRecebimento} />

                              <Route path="/fornecedoresGrupo/:id" component={ConfGrupoFornecedor} />

                              <Route path="/fornecedoresGrupo-ae/:id" component={ConfGrupoFornecedor_ae} />
                            </>
                          )}

                          {permissions['gerenciar-pedidos'] && (
                            <>
                              <Route
                                path="/gerenciarPedidos"
                                component={GerenciarPedidos}
                                title="Gerenciar Pedidos"
                                header={childMenu}
                              />

                              <Route
                                path="/gerenciarPedidos/tab/:tabId"
                                component={GerenciarPedidos}
                                title="Gerenciar Pedidos"
                                header={childMenu}
                              />
                            </>
                          )}

                          {checkPermission && (
                            <Route
                              path="/gerenciarPedidos/protocoloagendamento/opcaorecebimento"
                              component={AlterarOpcRecebProtocAgend}
                              title="Gerenciar Pedidos"
                            />
                          )}

                          {permissions['logs'] && <Route path="/logs" component={Logs} />}
                          {permissions['fale-conosco'] && <Route path="/contact" component={Contact} />}

                          {permissions['protocolo-logistico'] && (
                            <Route path="/protocoloLogistico" component={ProtocoloLogistico} />
                          )}

                          {permissions['manter-contatos'] && (
                            <>
                              <Route path="/grupos" component={Grupos} title="grupo" />

                              <Route path="/grupos-ae" component={Grupos_ae} title="grupo" />

                              <Route path="/grupos-ae/:id" component={Grupos_ae} title="grupo" />
                            </>
                          )}

                          {permissions['lista-de-usuarios'] && <Route path="/usuarios" component={Usuarios} />}

                          {permissions['lista-de-notas'] && <Route path="/notas" component={Invoices} />}
                          {permissions['acesso-envio-de-notas'] && (
                            <Route path="/notas/enviar" component={SendInvoice} />
                          )}

                          {permissions['qualidade'] && (
                            <>
                              <Route exact path="/qualidade" component={Qualidade} />

                              <Route path="/qualidade/adicionar-ficha-tecnica" component={AdicionarFichaTecnica} />
                            </>
                          )}

                          {permissions['devolucao-recebimentos'] && (
                            <>
                              <Route path="/qualidade/devolucao" component={ProductReturn} />

                              <Route path="/qualidade/devolucao/novo-relatorio" component={ProductReturnAdd} />

                              <Route
                                path="/qualidade/devolucao/relatorio/:personId/:returnReceiptId"
                                component={ProductReturnView}
                              />
                            </>
                          )}

                          {permissions['protocolo-de-agendamento'] && <Route path="/protocolos" component={Protocolos} />}

                          {permissions['user-scorecard'] && <Route path="/scorecard" component={Scorecard} />} Adiciona provider para fornecedores)

                          {permissions['lista-de-usuarios'] && (
                            <>
                              <Route path="/permissao" component={Permissoes} />
                              <Route path="/permissao-ae" component={Permissoes_ae} />
                              <Route path="/permissao-ae/:id" component={Permissoes_ae} />
                            </>
                          )}

                          {permissions['condicoes-de-pagamento'] && (
                            <>
                              <Route path="/manutencaoCondicoesPagamento" component={ManutencaoCondicoesPagamento} />

                              <Route
                                path="/manutencaoCondicoesPagamento-ae"
                                component={ManutencaoCondicoesPagamento_ae}
                              />

                              <Route
                                path="/manutencaoCondicoesPagamento-ae/:id"
                                component={ManutencaoCondicoesPagamento_ae}
                              />
                            </>
                          )}

                          {permissions['historico-de-agendamento'] && (
                            <>
                              <Route path="/historico-de-agendamento" component={OrderHistory} />
                              <Route
                                path="/historico-de-agendamento/detalhes/:purchaseOrderId/:productId/:deliveryDate/:branchId"
                                component={OrderHistoryDetails}
                              />
                            </>
                          )}

                          {permissions['documentos.cadastro-compl'] && (
                            <Route path="/cadastroComplementar" component={ComplementaryRegistration} />
                          )}
                          {permissions['listar-formularios'] && (
                            <>
                              <Route path="/formularios" component={Forms} />
                              <Route path="/formularios/responder/:id" component={FormAnswer} />
                            </>
                          )}
                          {permissions['gerenciar-formularios'] && (
                            <>
                              <Route path="/formularios/cadastrar" component={FormsCreate} />
                              <Route path="/formularios/editar/:id" component={FormsCreate} />
                            </>
                          )}
                        </Route>
                      </Router>
                    </ThemeProvider>
                  </SuppliersProvider>
                </ManageOrderProvider>
              </ApolloClientProvider>
            </RecoilRoot>
          </AuthProviderTs>
        </AuthProvider>,
        document.getElementById('root')
      );

      serviceWorker.unregister();
    } else {
      document.cookie = 'User-Token=; Max-Age=-99999999;';
      //Sem autentificacao
      ReactDOM.render(<Login />, document.getElementById('root'));
    }
  } catch (error) {
    if (process.env.REACT_APP_DEBUG === 'TRUE') ReactDOM.render(error.props, document.getElementById('root'));
    else ReactDOM.render(<Error message={error.props} />, document.getElementById('root'));

    //auditoria
    let str = 'Erro na verificação de login! ' + 'Error:( Message: ' + error.message + ', Stack: ' + error.stack + ' )';
    Log.error(token, str);
    console.error(error);
  }
};

run();
